import React from 'react';
import { SparkContentLoader } from '@sparknz/spark-pattern-library';

import PlanCardLoaders from '../../../shared/components/PlanCardLoaders';

export default function SubCategoryContentLoader() {
  return (
    <>
      <SparkContentLoader
        height={48}
        width={220}
        data-testid="sub-category-content-loader"
      >
        <rect x="0" y="0" rx="24" ry="24" width="100%" height="100%" />
      </SparkContentLoader>
      <PlanCardLoaders />
    </>
  );
}
